/* eslint-disable react-refresh/only-export-components --
 * Co-locates the filter/sort type contract with the toolbar component.
 * Editing this file forces a full reload during dev — acceptable trade-off.
 */
import styles from './ArtToolbar.module.css';

export type Genre = 'ALL' | 'TECHNO' | 'HOUSE' | 'EXPERIMENTAL' | 'BREAKS' | 'DEEP';
export type SortKey = 'alpha' | 'since' | 'tag';

export const ALL_GENRES: Genre[] = ['ALL', 'TECHNO', 'HOUSE', 'EXPERIMENTAL', 'BREAKS', 'DEEP'];

export const SORTS: { id: SortKey; lbl: string }[] = [
  { id: 'alpha', lbl: 'A→Z' },
  { id: 'since', lbl: 'SINCE' },
  { id: 'tag', lbl: 'TAG' },
];

interface ArtToolbarProps {
  filter: Genre;
  sort: SortKey;
  onFilterChange: (g: Genre) => void;
  onSortChange: (s: SortKey) => void;
}

export default function ArtToolbar({
  filter,
  sort,
  onFilterChange,
  onSortChange,
}: ArtToolbarProps) {
  return (
    <div className={styles.root}>
      <div className={styles.left}>
        {ALL_GENRES.map((g) => (
          <button
            key={g}
            type="button"
            className={'filter-btn' + (filter === g ? ' active' : '')}
            onClick={() => onFilterChange(g)}
          >
            {g}
          </button>
        ))}
      </div>
      <div className={styles.right}>
        <span className={styles.lbl}>SORT /</span>
        <div className={styles.sort}>
          {SORTS.map((s) => (
            <button
              key={s.id}
              type="button"
              className={sort === s.id ? 'active' : ''}
              onClick={() => onSortChange(s.id)}
            >
              {s.lbl}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
